// extracted by mini-css-extract-plugin
module.exports = {"layer":"CustomDragLayer_layer__3Oi1J"};